var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIcoDownload(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 15,
    height: 15,
    viewBox: "0 0 15 15",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M8.30983 9.80188C8.2769 9.83439 8.24236 9.86192 8.20449 9.88627C8.18808 9.8976 8.16995 9.90417 8.15354 9.91391C8.13219 9.92524 8.11074 9.93827 8.08606 9.94801C8.063 9.95775 8.04005 9.96262 8.01698 9.96908C7.99724 9.97553 7.9775 9.9821 7.95777 9.98697C7.91336 9.99513 7.86895 10 7.82282 10C7.77841 10 7.73239 9.99513 7.68787 9.98697C7.66652 9.98369 7.64839 9.97565 7.62866 9.96908C7.60559 9.96262 7.58264 9.95775 7.55957 9.94801C7.53651 9.93827 7.51516 9.92524 7.4921 9.91391C7.47569 9.90417 7.45756 9.89771 7.44115 9.88627C7.40328 9.86192 7.36713 9.83269 7.3358 9.80188L3.02389 5.54558C2.75571 5.28086 2.75571 4.85224 3.02389 4.58752C3.29206 4.3228 3.72628 4.3228 3.99446 4.58752L7.13836 7.68913V0.677158C7.13836 0.303694 7.44603 0 7.82437 0C8.20271 0 8.51037 0.303694 8.51037 0.677158V7.68913L11.651 4.58752C11.9192 4.3228 12.3534 4.3228 12.6216 4.58752C12.8898 4.85224 12.8898 5.28086 12.6216 5.54558L8.30983 9.80188Z",
    fill: "#0089B5"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M13.1612 14H1.66134C1.29655 14 0.99992 13.6776 0.99992 13.281V8.71895C0.99992 8.32244 1.29655 8 1.66134 8C2.02612 8 2.32275 8.32244 2.32275 8.71895V12.5619H12.4999V8.71895C12.4999 8.32244 12.7966 8 13.1613 8C13.5261 8 13.8228 8.32244 13.8228 8.71895V13.281C13.8228 13.6776 13.526 14 13.1612 14Z",
    fill: "#0089B5"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcoDownload);
export default __webpack_public_path__ + "static/media/ico_download.066970e90199bf5debafa13898c676da.svg";
export { ForwardRef as ReactComponent };